import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import './PublicPages.css';

const Courts = () => {
  const { courts } = useApp();
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('All');

  const filteredCourts = courts.filter(court => {
    const matchesSearch = court.courtName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         court.jurisdiction.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = filterType === 'All' || court.courtType === filterType;
    return matchesSearch && matchesType;
  });

  const courtTypes = ['All', ...new Set(courts.map(c => c.courtType))];

  return (
    <div className="courts-page">
      <div className="page-header">
        <div className="container">
          <h1>Courts Directory</h1>
          <p>Find information about all courts in our system</p>
        </div>
      </div>

      <div className="container">
        <div className="courts-filters">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search by court name or jurisdiction..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
          <div className="filter-box">
            <label>Filter by Type:</label>
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              className="filter-select"
            >
              {courtTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>
        </div>

        {filteredCourts.length > 0 ? (
          <div className="courts-grid">
            {filteredCourts.map(court => (
              <div key={court.id} className="court-card">
                <div className="court-header">
                  <h3>{court.courtName}</h3>
                  <span className="court-type-badge">{court.courtType}</span>
                </div>
                <div className="court-details">
                  <div className="court-detail-item">
                    <strong>Jurisdiction:</strong> {court.jurisdiction}
                  </div>
                  {court.address && (
                    <div className="court-detail-item">
                      <strong>Address:</strong> {court.address}
                    </div>
                  )}
                  {court.contactNumber && (
                    <div className="court-detail-item">
                      <strong>Phone:</strong> {court.contactNumber}
                    </div>
                  )}
                  {court.email && (
                    <div className="court-detail-item">
                      <strong>Email:</strong> {court.email}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <p>No courts found matching your search criteria.</p>
            {courts.length === 0 && (
              <p>No courts have been added to the system yet.</p>
            )}
          </div>
        )}

        <div className="courts-info">
          <h2>About Our Courts</h2>
          <p>
            Our e-Court Management System supports various types of courts including Supreme Court,
            High Court, District Court, Session Court, and Magistrate Court. Each court maintains
            its own jurisdiction and operates independently while being part of the integrated system.
          </p>
          <p>
            For case-related queries, please use our <a href="/case-status">Case Status</a> tracking
            system or <a href="/contact">contact us</a> for assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Courts;

